/**
 * Calculates the differences between current and desired ACL states to determine
 * what operations need to be performed.
 *
 * @param prev - Current ACL items (with existing IDs)
 * @param next - Desired ACL items (may include new items without IDs)
 * @returns Object containing arrays of ACL items to create, update, or delete
 * @returns returns.toCreate - New ACL items without IDs that need to be created
 * @returns returns.toUpdate - Existing ACL items with changed actions that need updating
 * @returns returns.toDelete - Current ACL items not present in the desired state
 */
export function calculateACLChanges(prev, next) {
    const toCreate = next.filter((acl) => !acl.id);
    const toUpdate = next.filter((acl) => {
        var _a;
        if (!acl.id) {
            return false;
        }
        const initialAcl = prev.find((existingAcl) => existingAcl.id === acl.id);
        const initialAclValue = (_a = initialAcl === null || initialAcl === void 0 ? void 0 : initialAcl.actions) === null || _a === void 0 ? void 0 : _a.toSorted().join(',');
        const newAclValue = acl.actions.toSorted().join(',');
        if (initialAclValue === newAclValue) {
            return false;
        }
        return true;
    });
    const toDelete = prev.filter((acl) => !next.some((newAcl) => newAcl.id === acl.id));
    return {
        toCreate,
        toUpdate,
        toDelete,
    };
}
